import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import SolubilityQuizScores from './solubility-quiz-scores.component';

export class SolubilityQuizComponent {
    constructor() {
        this.componentName = "solubilityQuizComponent";
        this.template = `
            <h3>Solubility Quiz Results</h3>
            <h5>Select month for quiz scores</h5>
            <table class="table table-hover">
            <thead>
                <tr>
                <th scope="col">Month</th>
                <th scope="col">Total</th>
                </tr>
            </thead>
            <tbody id="data_row">
                <tr class="table-default">
                <td scope="row">January 2020</td>
                <td>100</td>
                </tr>
            </tbody>
            </table>
        `;

        this.rowTemplate = `
        <tr class="table-default">
          <td scope="row" onClick="_cmp.solubilityQuiz.showQuizResults('{Year}{Month}', this.innerHTML)">{MonthYear}</td>
          <td>{Count}</td>
        </tr>
        `;

        this.cache = undefined;
		this.cacheExpiration = undefined;
    }
	
	
	render() {
        _svc.common.renderResults("SolubilityQuiz", _cmp.solubilityQuiz);
    }
    
	postBackSuccess(data) {
        _svc.common.populateDataRows(data, _cmp.solubilityQuiz.rowTemplate, _cmp.solubilityQuiz.componentName, _cmp.solubilityQuiz.template);
		_svc.common.handleCache(_cmp.solubilityQuiz);
	}
	
	postBackFailed() {
		_svc.util.clear("#" + _cmp.solubilityQuiz.componentName);
	}
	
	showQuizResults(yearMonth, monthYear) {
		_cmp.solubilityQuizScores.render(yearMonth, monthYear);
	}
	
	cacheExpired() {
		if (_cmp.solubilityQuiz.cacheExpiration == undefined) return true;
		if (_cmp.solubilityQuiz.cache == undefined) return true;
		return _cmp.solubilityQuiz.cacheExpiration < _svc.util.now();
	}
};

setTimeout(() => {
    _cmp.solubilityQuiz = new SolubilityQuizComponent();
}, 1);